export default {
  title: 'Arena-д шинээр юу нэмэгдсэн бэ',
  since: '{{version}} хувилбараас',
  experimental: 'Туршилтын',
  dontShowAgain: 'Дахин харуулахгүй',
  slideCounter: '{{current}} / {{total}}',
  noItems: 'Харуулах шинэ боломж алга.',
  items: {
    requiredIf: {
      title: 'Нөхцөлөөс хамаарч заавал бөглөх шинж чанар',
      description: `Маягт зохиогчид шинж чанарын **Баталгаажуулалтууд** табаас **Required when condition is met** (нөхцөл биелэх үед заавал) сонголтыг сонгоод нөхцөлөө бичнэ: нөхцөл үнэн байх үед л шинж чанар заавал бөглөгдөх ёстой болно.

Өгөгдөл оруулах үед "Шаардлагатай утга" алдаа зөвхөн нөхцөл биелсэн үед харагдана.`,
    },
    themeSelector: {
      title: 'Цайвар болон бараан загвар',
      description: `Толгой хэсгийн (нэвтрэх хуудсанд мөн байгаа) **Загвар** цэсээр **Цайвар** болон **Бараан** загварын хооронд шилжих, эсвэл **Системийн тохиргоо**-г дагах боломжтой.`,
    },
    surveyCompare: {
      title: 'Судалгааг харьцуулах, шинэчлэх',
      description: `**Хяналтын самбар** дээр **Нарийвчилсан функцууд > Харьцуулах / файлаас шинэчлэх**-ийг ашиглан энэ судалгааг өөр Arena серверээс (жишээ нь туршилтын сервер) экспортолсон судалгаа эсвэл энэ сервер дээрх өөр судалгаатай харьцуулна уу.

Ялгааг хянаж, зөвхөн сонгосон өөрчлөлтүүдийг хэрэгжүүлнэ: судалгааг нийтлэх хүртэл тэдгээр нь ноорог хэлбэрээр хадгалагдана.`,
    },
    usersBackup: {
      title: 'Хэрэглэгчдийг нөөцлөх, сэргээх',
      description: `**Хэрэглэгчид** хэсэгт **Нөөцлөх / Сэргээх**-ийг ашиглан бүх хэрэглэгчийг судалгааны үүрэг, хэрэглэгчийн бүлгийн хамт экспортолж, өөр Arena сервер рүү сэргээнэ.

Сэргээхээс өмнө хэрэглэгч бүрийн хувьд юу хийхийг сонгох боломжтой.`,
    },
    samplingPointDataWhisp: {
      title: 'Дээж цэгүүдийн Whisp шинжилгээ',
      description: `**Дээж цэгийн өгөгдлийн** ангилалд **Whisp шинжилгээ үүсгэх**-ийг ашиглан бүх дээж цэгийн байршлыг **Open Foris Whisp**-ээр шинжилнэ.

Шинжилгээ арын горимд ажиллаж, үр дүн нь шинэ ангилалд хадгалагдана.`,
    },
    dashboardUpgrade: {
      title: 'Шинэ хяналтын самбар',
      description: `**Хяналтын самбар** шинэ төрхтэй боллоо: бүртгэл, оролцогчдыг нэг дороос харах, цуглуулсан өгөгдлийн газрын зураг, нэмэгдсэн бүртгэлийн хандлага.`,
    },
    clearNonApplicableValues: {
      title: 'Хамааралгүй утгууд арилгагдана',
      description: `Өгөгдөл оруулах үед аливаа өөрчлөлт бусад талбаруудыг хамааралгүй болгосон тохиолдолд таны баталгаажуулалтын дараа тэдгээрийн утгууд арилгагдана.

Судалгааны админууд **Хамааралгүй шинж чанаруудын утгыг хадгалах** (**Судалгааны мэдээлэл > Аюулгүй байдал**) тохиргоогоор өмнөх үйлдлийг хадгалах боломжтой.`,
    },
    systemLogs: {
      title: 'Системийн бүртгэл',
      description: `**Системийн удирдлага > Системийн бүртгэл** хэсэгт серверийн бүртгэлийг текст, түвшний шүүлтүүрээр шууд хянана уу.`,
    },
    dataQueryAiGenerate: {
      title: 'Өгөгдөл судлагчийн асуулгыг AI-аар үүсгэх',
      description: `**Өгөгдөл судлагч** хэсэгт хайж буй өгөгдлөө энгийн үгээр тайлбарлахад (жишээ нь *"аймаг бүрийн модны тоо зүйлээр"*) AI танд асуулгыг үүсгэнэ.

Асуулгыг хадгалахдаа AI нэр болон тайлбар санал болгож чадна.

*Хэрэглэгчийн профайлд AI боломжуудыг идэвхжүүлсэн байх шаардлагатай.*`,
    },
    recordPrint: {
      title: 'Бичлэг хэвлэх',
      description: `Бичлэг засварлагчийн PDF товчоор бичлэгийг зурагтай нь хамт хэвлэх боломжтой **Word** эсвэл **PDF** баримт болгон экспортлоорой.

Хуудасны чиглэлийг (босоо эсвэл хэвтээ) сонгох боломжтой.`,
    },
    attributeClone: {
      title: 'Маягт зохиогчид атрибут хувилах',
      description: `**Маягт зохиогч** дээр атрибутын цэсийг ашиглан түүнийг ижил эсвэл өөр нэгж рүү **хувилна**: бүх шинж чанар хуулагдана.`,
    },
    odkImport: {
      title: 'ODK-оос судалгаа болон өгөгдөл импортлох',
      description: `**ODK маягтаас (.xml)** шинэ судалгаа үүсгэж, **ODK Collect**-оор цуглуулсан өгөгдлийг импортлоорой.

*Энэ боломж бета хувилбартай байна.*`,
    },
    dynamicEnumerator: {
      title: 'Нэгжийн динамик тоочилт',
      description: `Тоочсон олон нэгжийн мөрүүдийг үүсгэх ангиллын зүйлсийг **илэрхийллээр** сонгоно: жишээ нь \`unique(plot.land_use)\` нь зөвхөн талбайнуудад бүртгэгдсэн газар ашиглалтын төрлүүдэд мөр үүсгэнэ.`,
    },
  },
}
